<pg-linear-loader
  [attr.mode]="model?.mode"
  [mode]="model?.mode"
  [hidden]="model?.hidden"
  [styleOverides]="model"
>
  <pg-linear-loader-message
    *ngFor="let message of model.messages"
    [delay]="message.delay ? message.delay : 0"
    [duration]="message.duration ? message.duration : 2"
    >{{ message.message }}</pg-linear-loader-message
  >
</pg-linear-loader>
